import { CART_STATUS } from '../../constants';
import { parseWipayDataQueryParam } from './parseWipayCallback';

/**
 * Build receipt UI data from WiPay redirect query params when full Firestore
 * fulfillment is slow or timed out.
 * @param {Record<string, string>} q
 * @param {number} confirmationFee
 * @param {string} paymentGateway
 * @param {string} paymentMethod
 */
export function buildMinimalCallbackTransaction(
  q,
  { confirmationFee, paymentGateway, paymentMethod }
) {
  const checkoutData = parseWipayDataQueryParam(q.data);
  const isSuccess = q.status === 'success';
  const orderSubtotal =
    Number(checkoutData.orderSubtotal) || parseFloat(q.order_subtotal) || 0;
  const deliveryFee = Number(checkoutData.deliveryFee ?? checkoutData.delivery_fee) || 0;
  const fee = Number(checkoutData.confirmationFee) || confirmationFee;
  const paymentType =
    checkoutData.paymentType || q.payment_type || 'confirmation_fee_only';
  const isFullPayment = paymentType === 'full';

  const fallbackTotal = isFullPayment
    ? orderSubtotal + fee + deliveryFee
    : fee + deliveryFee;
  const amountPaid = parseFloat(q.total);
  const total = Number.isFinite(amountPaid) ? amountPaid : fallbackTotal;

  return {
    userId: checkoutData.userId || q.user_id || 'unknown',
    cartDocId: checkoutData.cartDocId || q.user_id || null,
    supermarketId:
      checkoutData.supermarketId ||
      checkoutData.supermarket_id ||
      q.supermarket_id ||
      'unknown',
    supermarketName:
      checkoutData.supermarketName || q.supermarket_name || 'Unknown Supermarket',
    customerName: checkoutData.customerName || q.customer_name || 'Customer',
    cartInstanceId: checkoutData.cartInstanceId || q.order_id,
    cartItems: checkoutData.cartItems || [],
    confirmationFee: fee,
    orderSubtotal,
    paymentType,
    deliveryOption: checkoutData.deliveryOption || q.delivery_option || 'pickup',
    deliveryAddress: checkoutData.deliveryAddress || q.delivery_address || null,
    deliveryPhone: checkoutData.deliveryPhone || q.delivery_phone || null,
    deliveryFee,
    maxDeliveryDistance: checkoutData.maxDeliveryDistance || null,
    status: isSuccess ? CART_STATUS.AWAITING_PACKING : CART_STATUS.PAYMENT_FAILED,
    amountPaid: isSuccess ? total : 0,
    paymentGatewayTransactionId: q.transaction_id || q.order_id || `callback_${Date.now()}`,
    paymentGateway,
    paymentMethod: q.method || paymentMethod,
    message:
      q.message ||
      (isSuccess
        ? 'Payment received. Order details may still be updating.'
        : 'Payment was not completed.'),
    total,
    createdAt: new Date(),
    updatedAt: new Date(),
  };
}
